import * as React from "react";

const Image = ({ data }) => {
  switch (data.layout) {
    case "FullWidth":
      return (
        <div className="w-full aspect-[1280/282]">
          <img
            src={data.asset.url}
            alt={data.asset?.title ? data.asset.title :  data.title}
            className="w-full h-full object-cover"
          />
        </div>
      );
    default:
      return null;
  }
};

export default Image;
